module.exports = __webpack_public_path__ + "static/media/sidemenu.c538e710.jpg";